import React from "react";

const MAP = {
  NEW: { bg: "#E0E7FF", text: "#4338CA", border: "#A5B4FC", label: "NEW", dot: "🔵", testid: "status-badge-new" },
  ACCEPTED: { bg: "#E0E7FF", text: "#4338CA", border: "#A5B4FC", label: "ACCEPTED", dot: "🔵", testid: "status-badge-accepted" },
  "IN PRODUCTION": { bg: "#FEF9C3", text: "#A16207", border: "#FDE047", label: "IN PRODUCTION", dot: "🟡", testid: "status-badge-in-production" },
  "READY FOR OWNER CHECK": { bg: "#E0E7FF", text: "#4338CA", border: "#A5B4FC", label: "READY FOR CHECK", dot: "🔍", testid: "status-badge-ready" },
  COMPLETED: { bg: "#D1FAE5", text: "#047857", border: "#6EE7B7", label: "COMPLETED", dot: "✅", testid: "status-badge-completed" },
  CANCELLED: { bg: "#F1F5F9", text: "#64748B", border: "#CBD5E1", label: "CANCELLED", dot: "⚪", testid: "status-badge-cancelled" },
};

export function StatusBadge({ status }) {
  const s = MAP[status] || MAP.NEW;
  return (
    <span
      data-testid={s.testid}
      className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wide"
      style={{ backgroundColor: s.bg, color: s.text, border: `1px solid ${s.border}` }}
    >
      <span>{s.dot}</span>
      {s.label}
    </span>
  );
}

export function DeadlineBadge({ job }) {
  // completed job -> show result; active -> show deadline state
  if (job.result) {
    if (job.result.on_time) {
      const early = job.result.days_early;
      return (
        <span data-testid="status-badge-on-track" className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold uppercase"
          style={{ backgroundColor: "#DCFCE7", color: "#15803D", border: "1px solid #86EFAC" }}>
          ✅ ON TIME{early > 0 ? ` · ${early} DAY${early > 1 ? "S" : ""} EARLY` : ""}
        </span>
      );
    }
    return (
      <span data-testid="status-badge-breached" className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold uppercase"
        style={{ backgroundColor: "#FEE2E2", color: "#B91C1C", border: "1px solid #FCA5A5" }}>
        🔴 BREACHED · {job.result.days_breached} DAY{job.result.days_breached > 1 ? "S" : ""}
      </span>
    );
  }
  const state = job.deadline_state;
  if (job.status === "READY FOR OWNER CHECK") {
    return (
      <span data-testid="status-badge-awaiting" className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold uppercase"
        style={{ backgroundColor: "#E0E7FF", color: "#4338CA", border: "1px solid #A5B4FC" }}>
        🔍 AWAITING CHECK
      </span>
    );
  }
  if (state === "RED") {
    return (
      <span data-testid="status-badge-breached" className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold uppercase"
        style={{ backgroundColor: "#FEE2E2", color: "#B91C1C", border: "1px solid #FCA5A5" }}>
        🔴 OVERDUE {Math.abs(job.days_left)} DAY{Math.abs(job.days_left) > 1 ? "S" : ""}
      </span>
    );
  }
  if (state === "YELLOW") {
    return (
      <span data-testid="status-badge-deadline-near" className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold uppercase"
        style={{ backgroundColor: "#FEF9C3", color: "#A16207", border: "1px solid #FDE047" }}>
        🟡 {job.days_left === 0 ? "DUE TODAY" : `${job.days_left} DAY${job.days_left > 1 ? "S" : ""} LEFT`}
      </span>
    );
  }
  return (
    <span data-testid="status-badge-on-track" className="inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-xs font-bold uppercase"
      style={{ backgroundColor: "#DCFCE7", color: "#15803D", border: "1px solid #86EFAC" }}>
      🟢 {job.days_left} DAYS LEFT
    </span>
  );
}
